import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Icon.module.scss.js';

var iconSizes = ['xsmall', 'small', 'medium', 'mediumplus', 'large', 'xlarge'];
function Icon(_a) {
    var _this = this;
    var icon = _a.icon, size = _a.size, className = _a.className, onClick = _a.onClick, dataTestId = _a.dataTestId, color = _a.color, mouseOver = _a.mouseOver, mouseLeave = _a.mouseLeave, rotate = _a.rotate, shadow = _a.shadow, tabIndex = _a.tabIndex;
    var _b = useState(''), path = _b[0], setPath = _b[1];
    var getPathLazy = function () { return __awaiter(_this, void 0, void 0, function () {
        var iconsDef, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('./svg/cleaned_icons.json.js')];
                case 1:
                    iconsDef = (_a.sent()).default;
                    result = Object.values(iconsDef).find(function (i) { return i.name === icon; });
                    return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.paths) && setPath(result === null || result === void 0 ? void 0 : result.paths.join(' '))];
            }
        });
    }); };
    getPathLazy();
    var svgIcon = function (testId, customClass) { return (React.createElement("svg", { onMouseOver: mouseOver, onMouseLeave: mouseLeave, onFocus: mouseOver, onBlur: mouseLeave, id: testId || undefined, role: "img", className: classNames(styles['svg-icon'], customClass, styles[size], icon, rotate && styles.rotate, shadow && styles.shadow), viewBox: "0 0 1024 1024" },
        React.createElement("path", { d: path, fill: color !== null && color !== void 0 ? color : '' }))); };
    return onClick ? (React.createElement("button", { type: "button", onClick: onClick, className: classNames(styles['svg-icon-button'], className), id: dataTestId, tabIndex: tabIndex }, svgIcon())) : (svgIcon(dataTestId, className));
}
Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    color: PropTypes.string,
    size: PropTypes.oneOf(iconSizes),
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    onClick: PropTypes.func,
    mouseOver: PropTypes.func,
    mouseLeave: PropTypes.func,
    rotate: PropTypes.bool,
    shadow: PropTypes.bool,
    tabIndex: PropTypes.number,
};
Icon.defaultProps = {
    className: '',
    onClick: null,
    mouseOver: null,
    mouseLeave: null,
    dataTestId: null,
    color: null,
    size: 'medium',
    rotate: false,
    shadow: false,
    tabIndex: 0,
};

export { Icon as default };
